import { DownloadOption } from 'types';

export const getDownloadQuality = (fileType: DownloadOption) => {
  if (fileType === DownloadOption.Wav) {
    return 'high';
  }
  return 'medium';
};
